<template>
  <a-config-provider>
    <div v-if="isLoginPage">
      <router-view />
    </div>
    <a-layout v-else style="min-height: 100vh">
      <a-layout-sider width="200" class="sidebar">
        <div class="sidebar-header">
          <div class="sidebar-title">神算子后台</div>
        </div>
        <a-menu
          v-if="!isLoginPage"
          v-model:selectedKeys="selectedKeys"
          v-model:openKeys="openKeys"
          mode="inline"
          :style="{ borderRight: 0 }"
          @click="handleMenuClick"
        >
          <a-menu-item key="dashboard">
            <template #icon><HomeOutlined /></template>
            <span>首页</span>
            <LinkOutlined class="menu-link-icon" @click.stop="handleOpenInNewTab('dashboard')" />
          </a-menu-item>
          <a-menu-item key="execution-plan-list" v-if="hasRole(['technician']) && !isAdmin()">
            <template #icon><DeploymentUnitOutlined /></template>
            <span>AI调用记录</span>
            <LinkOutlined class="menu-link-icon" @click.stop="handleOpenInNewTab('execution-plan-list')" />
          </a-menu-item>
          <a-sub-menu key="knowledge-mgmt" v-if="hasRole(['admin','editor'])">
            <template #icon>
              <FileTextOutlined />
            </template>
            <template #title>知识管理</template>
            <a-menu-item key="knowledge">
              <span>知识列表</span>
              <LinkOutlined class="menu-link-icon" @click.stop="handleOpenInNewTab('knowledge')" />
            </a-menu-item>
            <a-menu-item key="collection-condition">
              <span>采集工况</span>
              <LinkOutlined class="menu-link-icon" @click.stop="handleOpenInNewTab('collection-condition')" />
            </a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="workflow" v-if="isAdmin()">
            <template #icon>
              <DeploymentUnitOutlined />
            </template>
            <template #title>流程管理</template>
            <a-menu-item key="call-scheme" v-if="hasRole(['admin','editor'])">
              <span>AI调用流程</span>
              <LinkOutlined class="menu-link-icon" @click.stop="handleOpenInNewTab('call-scheme')" />
            </a-menu-item>
            <a-menu-item key="diagnosis-log-manage" v-if="hasRole(['admin','editor'])">
              <span>AI调用文案</span>
              <LinkOutlined class="menu-link-icon" @click.stop="handleOpenInNewTab('diagnosis-log-manage')" />
            </a-menu-item>
            <a-menu-item key="execution-plan-list" v-if="hasRole(['admin','technician'])">
              <span>AI调用记录</span>
              <LinkOutlined class="menu-link-icon" @click.stop="handleOpenInNewTab('execution-plan-list')" />
            </a-menu-item>
            <a-menu-item key="ai-simulator" v-if="isAdmin()">
              <span>AI调用模拟</span>
              <LinkOutlined class="menu-link-icon" @click.stop="handleOpenInNewTab('ai-simulator')" />
            </a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="eval-v2" v-if="isAdmin()">
            <template #icon>
              <ExperimentOutlined />
            </template>
            <template #title>评估系统</template>
            <a-menu-item key="eval-test-cases">
              <span>用例管理</span>
              <LinkOutlined class="menu-link-icon" @click.stop="handleOpenInNewTab('eval-test-cases')" />
            </a-menu-item>
            <a-menu-item key="model-comparison-list">
              <span>模型横向对比</span>
              <LinkOutlined class="menu-link-icon" @click.stop="handleOpenInNewTab('model-comparison-list')" />
            </a-menu-item>
            <a-menu-item key="ssz-benchmark-list">
              <span>模型对比2.0</span>
              <LinkOutlined class="menu-link-icon" @click.stop="handleOpenInNewTab('ssz-benchmark-list')" />
            </a-menu-item>
            <a-menu-item key="posttreatment-retest-list">
              <span>后处理屏蔽模型重复测试</span>
              <LinkOutlined class="menu-link-icon" @click.stop="handleOpenInNewTab('posttreatment-retest-list')" />
            </a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="config-tools" v-if="isAdmin()">
            <template #icon>
              <ToolOutlined />
            </template>
            <template #title>配置工具</template>
            <a-menu-item key="config">
              <span>配置管理</span>
              <LinkOutlined class="menu-link-icon" @click.stop="handleOpenInNewTab('config')" />
            </a-menu-item>
            <a-menu-item key="generate-prompt-structure">
              <span>生成提示词结构</span>
              <LinkOutlined class="menu-link-icon" @click.stop="handleOpenInNewTab('generate-prompt-structure')" />
            </a-menu-item>
            <a-menu-item key="generate-response-schema">
              <span>生成响应格式</span>
              <LinkOutlined class="menu-link-icon" @click.stop="handleOpenInNewTab('generate-response-schema')" />
            </a-menu-item>
            <a-menu-item key="reference-data-stream">
              <span>提取参考数据流</span>
              <LinkOutlined class="menu-link-icon" @click.stop="handleOpenInNewTab('reference-data-stream')" />
            </a-menu-item>
            <a-menu-item key="fault-code-explanation-log">
              <span>故障码解释日志</span>
              <LinkOutlined class="menu-link-icon" @click.stop="handleOpenInNewTab('fault-code-explanation-log')" />
            </a-menu-item>
            <a-menu-item key="posttreatment-check-log">
              <span>后处理屏蔽判断日志</span>
              <LinkOutlined class="menu-link-icon" @click.stop="handleOpenInNewTab('posttreatment-check-log')" />
            </a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="tag-mgmt" v-if="isAdmin()">
            <template #icon>
              <TagsOutlined />
            </template>
            <template #title>标签管理</template>
            <a-menu-item key="ext-tag-types">
              <span>标签类型管理</span>
              <LinkOutlined class="menu-link-icon" @click.stop="handleOpenInNewTab('ext-tag-types')" />
            </a-menu-item>
            <a-menu-item key="ext-independent-tags">
              <span>独立标签管理</span>
              <LinkOutlined class="menu-link-icon" @click.stop="handleOpenInNewTab('ext-independent-tags')" />
            </a-menu-item>
            <a-menu-item key="ext-cascade-tags">
              <span>联动标签管理</span>
              <LinkOutlined class="menu-link-icon" @click.stop="handleOpenInNewTab('ext-cascade-tags')" />
            </a-menu-item>
            <a-menu-item key="ext-composite-tags">
              <span>组合标签管理</span>
              <LinkOutlined class="menu-link-icon" @click.stop="handleOpenInNewTab('ext-composite-tags')" />
            </a-menu-item>
            <a-menu-item key="ext-system-tags">
              <span>系统标签管理</span>
              <LinkOutlined class="menu-link-icon" @click.stop="handleOpenInNewTab('ext-system-tags')" />
            </a-menu-item>
            <a-menu-item key="ext-ecu-brand-tags">
              <span>AI诊断流程管理</span>
              <LinkOutlined class="menu-link-icon" @click.stop="handleOpenInNewTab('ext-ecu-brand-tags')" />
            </a-menu-item>
            <a-menu-item key="ext-ecu-tags">
              <span>扩展标签管理</span>
              <LinkOutlined class="menu-link-icon" @click.stop="handleOpenInNewTab('ext-ecu-tags')" />
            </a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="sys-mgmt" v-if="isAdmin()">
            <template #icon>
              <TeamOutlined />
            </template>
            <template #title>系统管理</template>
            <a-menu-item key="model-call-stats">
              <span>模型调用监控</span>
              <LinkOutlined class="menu-link-icon" @click.stop="handleOpenInNewTab('model-call-stats')" />
            </a-menu-item>
            <a-menu-item key="user-manage">
              <span>用户管理</span>
              <LinkOutlined class="menu-link-icon" @click.stop="handleOpenInNewTab('user-manage')" />
            </a-menu-item>
          </a-sub-menu>
          <a-menu-item key="docs-index" v-if="isAdmin()">
            <template #icon>
              <BookOutlined />
            </template>
            <span>系统文档</span>
            <LinkOutlined class="menu-link-icon" @click.stop="handleOpenInNewTab('docs-index')" />
          </a-menu-item>
        </a-menu>
        <div class="sidebar-footer">
          <div class="user-info" v-if="currentUser">
            <UserOutlined style="margin-right:6px;color:#8c8c8c;" />
            <span class="user-display-name">{{ currentUser.displayName || currentUser.username }}</span>
            <a-button type="link" size="small" @click="changePwdVisible = true" class="change-pwd-btn">
              <template #icon><LockOutlined /></template>
            </a-button>
          </div>
          <a-button type="text" block @click="handleLogout" class="logout-btn">
            <template #icon>
              <LogoutOutlined />
            </template>
            退出登录
          </a-button>
        </div>
      </a-layout-sider>
      <a-layout-content class="main-content">
        <router-view />
      </a-layout-content>
      <!-- 右下角浮动刷新按钮：仅在主布局内显示，登录页不显示 -->
      <a-tooltip title="刷新当前页面" placement="left">
        <a-button
          type="primary"
          shape="circle"
          class="float-refresh-btn"
          aria-label="刷新当前页面"
          @click="handleRefreshPage"
        >
          <template #icon>
            <ReloadOutlined />
          </template>
        </a-button>
      </a-tooltip>
    </a-layout>
    <EnvWatermark v-if="envWatermark" :text="envWatermark.text" :color="envWatermark.color" />
    <!-- 修改密码弹窗 -->
    <a-modal
      v-model:open="changePwdVisible"
      title="修改密码"
      :confirm-loading="changePwdLoading"
      @ok="handleChangePwd"
      @cancel="changePwdVisible = false"
      ok-text="确认修改"
      cancel-text="取消"
    >
      <a-form layout="vertical">
        <a-form-item label="旧密码">
          <a-input-password v-model:value="changePwdForm.oldPassword" placeholder="请输入旧密码" />
        </a-form-item>
        <a-form-item label="新密码">
          <a-input-password v-model:value="changePwdForm.newPassword" placeholder="请输入新密码" />
        </a-form-item>
        <a-form-item label="确认新密码">
          <a-input-password v-model:value="changePwdForm.confirmPassword" placeholder="请再次输入新密码" />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-config-provider>
</template>

<script>
import { ref, watch, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import {
  FileTextOutlined,
  OrderedListOutlined,
  DeploymentUnitOutlined,
  DatabaseOutlined,
  PlayCircleOutlined,
  LogoutOutlined,
  SettingOutlined,
  ApiOutlined,
  ExperimentOutlined,
  ProjectOutlined,
  CheckCircleOutlined,
  BarChartOutlined,
  FormOutlined,
  TagsOutlined,
  ToolOutlined,
  BookOutlined,
  LinkOutlined,
  ReloadOutlined,
  UserOutlined,
  LockOutlined,
  TeamOutlined,
  HomeOutlined
} from '@ant-design/icons-vue';
import { Menu, message } from 'ant-design-vue';
import { logout } from './api/auth';
import { clearToken } from './api/request';
import { changeMyPassword } from './api/users';
import EnvWatermark from './components/EnvWatermark.vue';
import { useSystemInfo } from './composables/useSystemInfo';
import { useAuth } from './composables/useAuth';

export default {
  name: 'App',
  components: {
    FileTextOutlined,
    OrderedListOutlined,
    DeploymentUnitOutlined,
    DatabaseOutlined,
    PlayCircleOutlined,
    LogoutOutlined,
    SettingOutlined,
    ApiOutlined,
    ExperimentOutlined,
    ProjectOutlined,
    CheckCircleOutlined,
    BarChartOutlined,
    FormOutlined,
    TagsOutlined,
    ToolOutlined,
    BookOutlined,
    LinkOutlined,
    ReloadOutlined,
    UserOutlined,
    LockOutlined,
    TeamOutlined,
    HomeOutlined,
    EnvWatermark
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const isLoginPage = ref(false);
    const selectedKeys = ref(['dashboard']);
    const openKeys = ref([]);

    // 角色权限
    const { hasRole, isAdmin, currentUser } = useAuth();

    // 修改密码弹窗
    const changePwdVisible = ref(false);
    const changePwdLoading = ref(false);
    const changePwdForm = ref({ oldPassword: '', newPassword: '', confirmPassword: '' });

    const handleChangePwd = async () => {
      const { oldPassword, newPassword, confirmPassword } = changePwdForm.value;
      if (!oldPassword || !newPassword || !confirmPassword) {
        message.error('请填写所有密码字段');
        return;
      }
      if (newPassword !== confirmPassword) {
        message.error('两次输入的新密码不一致');
        return;
      }
      changePwdLoading.value = true;
      try {
        await changeMyPassword(oldPassword, newPassword);
        message.success('密码修改成功，请重新登录');
        changePwdVisible.value = false;
        changePwdForm.value = { oldPassword: '', newPassword: '', confirmPassword: '' };
        clearToken();
        router.push('/login');
      } catch (error) {
        message.error(error.message || '密码修改失败');
      } finally {
        changePwdLoading.value = false;
      }
    };

    // 检查是否是登录页
    watch(() => route.path, (path) => {
      isLoginPage.value = path === '/login';
    }, { immediate: true });

    // 根据路由更新选中菜单
    watch(() => route.name, (name) => {
      if (name && !isLoginPage.value) {
        // 知识管理相关页面
        if (name === 'knowledge' || name === 'knowledge-create' || name === 'knowledge-edit') {
          selectedKeys.value = ['knowledge'];
          openKeys.value = ['knowledge-mgmt'];
        } else if (name === 'collection-condition') {
          selectedKeys.value = ['collection-condition'];
          openKeys.value = ['knowledge-mgmt'];
        } else if (name === 'call-scheme' || name === 'call-step-manage' || name === 'output-params-list' || 
                   name === 'execution-plan-list' || name === 'execution-plan-detail' || name === 'execution-log-detail' ||
                   name === 'prompt-simulator' || name === 'diagnosis-log-manage' || name === 'diagnosis-display-stage' ||
                   name === 'diagnosis-log-item' || name === 'websocket-session-replay') {
          // 流程管理相关页面，展开父菜单并选中对应子菜单
          // call-step-manage 和 output-params-list 都是 call-scheme 的子页面
          // execution-plan-detail 和 execution-log-detail 都是 execution-plan-list 的子页面
          // prompt-simulator 对应 ai-simulator 菜单项
          // diagnosis-log-manage 的子页面都对应 diagnosis-log-manage 菜单项
          if (name === 'call-step-manage' || name === 'output-params-list') {
            selectedKeys.value = ['call-scheme'];
          } else if (name === 'execution-plan-detail' || name === 'execution-log-detail') {
            selectedKeys.value = ['execution-plan-list'];
          } else if (name === 'prompt-simulator') {
            selectedKeys.value = ['ai-simulator'];
          } else if (name === 'diagnosis-display-stage' || name === 'diagnosis-log-item' || name === 'websocket-session-replay') {
            selectedKeys.value = ['diagnosis-log-manage'];
          } else {
            selectedKeys.value = [name];
          }
          openKeys.value = ['workflow'];
        } else if (name === 'eval-test-cases' || name === 'eval-test-case-detail' ||
                   name === 'eval-test-plans' || name === 'eval-test-plan-create' ||
                   name === 'eval-results' || name === 'eval-execution-detail' ||
                   name === 'eval-analysis' || name === 'eval-score-templates' ||
                   name === 'model-comparison-list' || name === 'model-comparison-detail' ||
                   name === 'ssz-benchmark-list' || name === 'ssz-benchmark-detail' ||
                   name === 'posttreatment-retest-list' || name === 'posttreatment-retest-detail') {
          // 评估系统相关页面，展开父菜单并选中对应子菜单
          if (name === 'eval-test-case-detail') {
            selectedKeys.value = ['eval-test-cases'];
          } else if (name === 'eval-execution-detail') {
            selectedKeys.value = ['eval-results'];
          } else if (name === 'eval-test-plan-create') {
            selectedKeys.value = ['eval-test-plans'];
          } else if (name === 'model-comparison-detail') {
            selectedKeys.value = ['model-comparison-list'];
          } else if (name === 'ssz-benchmark-detail') {
            selectedKeys.value = ['ssz-benchmark-list'];
          } else if (name === 'posttreatment-retest-detail') {
            selectedKeys.value = ['posttreatment-retest-list'];
          } else {
            selectedKeys.value = [name];
          }
          openKeys.value = ['eval-v2'];
        } else if (name === 'config') {
          selectedKeys.value = ['config'];
          openKeys.value = ['config-tools'];
        } else if (name === 'api-management' || name === 'api-doc' || name === 'api-test') {
          selectedKeys.value = ['api-management'];
          openKeys.value = ['config-tools'];
        } else if (name === 'queue-board') {
          selectedKeys.value = ['queue-board'];
          openKeys.value = ['config-tools'];
        } else if (name === 'model-call-stats' || name === 'model-call-detail') {
          selectedKeys.value = ['model-call-stats'];
          openKeys.value = ['sys-mgmt'];
        } else if (name === 'generate-response-schema' || name === 'generate-prompt-structure') {
          selectedKeys.value = [name];
          openKeys.value = [];
        } else if (name === 'external-frame') {
          // 外部系统页面，根据路由参数确定选中的菜单
          const pageMap = {
            'tag-types': 'ext-tag-types',
            'independent-tags': 'ext-independent-tags',
            'cascade-tags': 'ext-cascade-tags',
            'composite-tags': 'ext-composite-tags',
            'system-tags': 'ext-system-tags',
            'ecu-brand-tags': 'ext-ecu-brand-tags',
            'ecu-tags': 'ext-ecu-tags'
          };
          const page = route.params.page;
          selectedKeys.value = [pageMap[page] || ''];
          openKeys.value = ['tag-mgmt'];
        } else if (name === 'dashboard') {
          selectedKeys.value = ['dashboard'];
          openKeys.value = [];
        } else if (name === 'docs-index' || name === 'docs-category' || name === 'docs-detail') {
          // 系统文档页面
          selectedKeys.value = ['docs-index'];
          openKeys.value = [];
        } else if (name === 'user-manage') {
          selectedKeys.value = ['user-manage'];
          openKeys.value = ['sys-mgmt'];
        } else {
          selectedKeys.value = [name];
        }
      } else {
        // 如果是登录页或没有路由名称，清空选中状态
        selectedKeys.value = [];
        openKeys.value = [];
      }
    }, { immediate: true });

    // 外部系统页面映射（key -> 路由参数）
    const externalPages = {
      'ext-tag-types': 'tag-types',
      'ext-independent-tags': 'independent-tags',
      'ext-cascade-tags': 'cascade-tags',
      'ext-composite-tags': 'composite-tags',
      'ext-system-tags': 'system-tags',
      'ext-ecu-brand-tags': 'ecu-brand-tags',
      'ext-ecu-tags': 'ecu-tags'
    };

    // 根据菜单key生成路由路径
    const getRoutePath = (key) => {
      // 外部系统页面（iframe 嵌入）
      if (externalPages[key]) {
        return router.resolve({ name: 'external-frame', params: { page: externalPages[key] } }).href;
      }
      // 接口管理页面
      if (key === 'api-management') {
        return '/api-management';
      }
      // 队列管理页面
      if (key === 'queue-board') {
        return '/queue-board';
      }
      // 系统文档页面
      if (key === 'docs-index') {
        return '/docs';
      }
      // AI调用文案菜单项指向展示阶段管理页面
      if (key === 'diagnosis-log-manage') {
        return '/diagnosis-log/stages';
      }
      // ai调用模拟
      if (key === 'ai-simulator') {
        return router.resolve({ name: 'prompt-simulator' }).href;
      }
      // 其他页面使用路由名称
      return router.resolve({ name: key }).href;
    };

    // 在新标签页打开链接
    const handleOpenInNewTab = (key) => {
      const path = getRoutePath(key);
      window.open(path, '_blank');
    };

    const handleMenuClick = ({ key }) => {
      // 如果是父菜单，不处理
      if (key === 'workflow' || key === 'eval-v2' || key === 'knowledge-mgmt' || key === 'tag-mgmt' || key === 'config-tools' || key === 'sys-mgmt') {
        return;
      }
      // 用户管理
      if (key === 'user-manage') {
        router.push({ name: 'user-manage' });
        return;
      }
      // ai调用模拟 - 使用路由跳转
      if (key === 'ai-simulator') {
        router.push({ name: 'prompt-simulator' });
        return;
      }
      // 外部系统页面（iframe 嵌入）
      if (externalPages[key]) {
        router.push({ name: 'external-frame', params: { page: externalPages[key] } });
        return;
      }
      // 接口管理页面
      if (key === 'api-management') {
        router.push('/api-management');
        return;
      }
      // 队列管理页面
      if (key === 'queue-board') {
        router.push('/queue-board');
        return;
      }
      // 系统文档页面
      if (key === 'docs-index') {
        router.push('/docs');
        return;
      }
      // AI调用文案菜单项指向展示阶段管理页面
      if (key === 'diagnosis-log-manage') {
        router.push('/diagnosis-log/stages');
        return;
      }
      router.push({ name: key });
    };

    // 退出登录
    const handleLogout = async () => {
      try {
        // 调用后端登出接口（可选）
        await logout();
      } catch (error) {
        console.warn('登出接口调用失败:', error);
      } finally {
        // 清除所有登录信息
        clearToken();
        router.push('/login');
      }
    };

    // 刷新当前页面（整页重载）
    const handleRefreshPage = () => {
      window.location.reload();
    };

    const { systemInfo } = useSystemInfo();
    const ENV_WATERMARK_MAP = {
      staging:     { text: '预发布环境', color: '#fa8c16' },
      test:        { text: '测试环境',   color: '#722ed1' },
      development: { text: '开发环境',   color: '#1677ff' },
    };
    const envWatermark = computed(() => {
      const id = systemInfo.value?.serverId;
      if (!id || id === 'prod') return null;
      return ENV_WATERMARK_MAP[id] ?? { text: id, color: '#f5222d' };
    });
    return {
      selectedKeys,
      openKeys,
      isLoginPage,
      handleMenuClick,
      handleLogout,
      handleOpenInNewTab,
      handleRefreshPage,
      envWatermark,
      hasRole,
      isAdmin,
      currentUser,
      changePwdVisible,
      changePwdLoading,
      changePwdForm,
      handleChangePwd
    };
  }
};
</script>

<style>
#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.sidebar {
  background: #f0f2f5 !important;
  display: flex;
  flex-direction: column;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
  overflow-x: hidden;
  overflow-y: auto;
}

.sidebar-header {
  padding: 16px 20px;
  background: #001529;
  border-bottom: 1px solid #1f1f1f;
  flex-shrink: 0;
  overflow: hidden;
}

.sidebar-title {
  color: white;
  font-size: 18px;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sidebar .ant-menu {
  background: #f0f2f5 !important;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
}

.sidebar .ant-menu-item {
  margin: 4px 8px;
  border-radius: 0px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  padding-right: 40px !important;
}

.sidebar .ant-menu-item .ant-menu-title-content {
  display: block;
  padding-right: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sidebar .ant-menu-item-selected {
  background-color: #fff !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.sidebar-footer {
  padding: 12px;
  border-top: 1px solid #d9d9d9;
  background: #f0f2f5;
  flex-shrink: 0;
  overflow: hidden;
}

.user-info {
  display: flex;
  align-items: center;
  padding: 6px 12px;
  color: #595959;
  font-size: 13px;
  overflow: hidden;
}

.user-display-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.change-pwd-btn {
  padding: 0 4px;
  color: #8c8c8c;
}

.change-pwd-btn:hover {
  color: #1890ff;
}

.logout-btn {
  color: #595959;
  height: 40px;
}

.logout-btn:hover {
  color: #1890ff;
  background-color: #fff;
}

.menu-link-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  color: #8c8c8c;
  opacity: 0;
  transition: opacity 0.2s;
  cursor: pointer;
}

.sidebar .ant-menu-item:hover .menu-link-icon {
  opacity: 1;
}

.menu-link-icon:hover {
  color: #1890ff;
}

.main-content {
  margin-left: 0;
  padding: 0 24px 24px;
  background: #fff;
  min-height: 100vh;
}

/* 右下角浮动刷新按钮：仅在主布局内显示 */
.float-refresh-btn {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 900;
  width: 48px;
  height: 48px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
</style>
